

$(function() {
  var side = $("#sidebar");
  var cont = $(".l-FAQ-0001");
  var sidebar = side.offset().top - 100;
  var content = cont.outerHeight() - 500;
  var common = $("#common").offset().top - 100;
  var monokura = $("#monokura").offset().top - 100;
  var rental= $("#rental").offset().top - 100;
  var bunshohokan= $("#bunshohokan").offset().top - 100;
  var logis= $("#logis").offset().top - 100;
  var otokura = $("#otokura").offset().top - 100;
  var tireyard = $("#tireyard").offset().top - 100;


  window.addEventListener( 'resize', function() {
    $(window).scrollTop(0);
  }, false );
  $(window).on("scroll", function() {
	var right = $('.pg-p-contact').css('margin-right');
    var scroll = $(window).scrollTop();
	side.css({position: "absolute", top: "90px", right: "0"});
    if(scroll >= sidebar) {
      
      
        side.css({position: "fixed", top: "100px", right: right});
    } else {
      side.css({position: "absolute", top: "90px", right: "0"});
    }

	if(scroll <= common) {
		$('.nav-bar').removeClass('active');
	}
	if(scroll >= common) {
		$('.nav-bar').removeClass('active');
		$('.common-nav').addClass('active');
	} 
	if(scroll >= monokura) {
		$('.nav-bar').removeClass('active');
		$('.monokura-nav').addClass('active');
	}
	if(scroll >= rental) {
		$('.nav-bar').removeClass('active');
		$('.rental-nav').addClass('active');
	}
	if(scroll >= bunshohokan) {
		$('.nav-bar').removeClass('active');
		$('.bunshohokan-nav').addClass('active');
	}
	if(scroll >= logis) {
		$('.nav-bar').removeClass('active');
		$('.logis-nav').addClass('active');
	}
	if(scroll >= otokura) {
		$('.nav-bar').removeClass('active');
		$('.otokura-nav').addClass('active');
	}
	if(scroll >= tireyard) {
		$('.nav-bar').removeClass('active');
		$('.tireyard-nav').addClass('active');
	}
	
	
  });
});

$(function(){
    $('.pg-p-contact-faq').find('.pg-p-text__section-title--charcter-line').each(function(){
        $(this).on('click',function(){
        	$(this).toggleClass('on');
            $("+.pg-p-contact-faq-list",this).slideToggle();
            return false;
        });
    });
});